import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';

import shapeImg1 from '../../assets/img/choose/shape-1-2.png';
import chooseImg from '../../assets/img/choose/choose-2-1.jpg';
import shapeImg2 from '../../assets/img/choose/shape-3-1.jpg';
import shapeImg3 from '../../assets/img/choose/shape-3-2.jpg';

const ChooseUs = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      id="it-choose"
      className="it-choose-area fix it-choose-style-2 p-relative pt-150 pb-150"
    >
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="PO_fBTkoznc"
        onClose={() => openModal()}
      />
      <div className="it-choose-shape-2 d-none d-xxl-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-7 col-lg-6">
            <div className="it-choose-left">
              <div className="it-choose-title-box mb-20">
                <span className="it-section-subtitle tertiary">
                  Why choose Us?
                </span>
                <h3 className="it-section-title">
                  A Holistic View On Eye Care <br />
                  And Health
                </h3>
              </div>

              <div className="it-choose-text mb-30">
                <p>
                  Neque porro quisquam est, qui dolorem ipsum quia dolor sit
                  amet, consectetur, <br /> adipisci velit, sed quia non numquam
                  eius modi tempora incidunt ut labore et <br /> dolore magnam
                  aliquam quaerat voluptatem.
                </p>
              </div>
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-20">
                  <div className="it-choose-staff style-1 d-flex align-items-center">
                    <div className="it-choose-staff-icon">
                      <span>
                        <i className="flaticon-doctor"></i>
                      </span>
                    </div>
                    <div className="it-choose-staff-text">
                      <h6 className="it-choose-staff-title">Eye Specialist</h6>
                      <p className="mb-0">
                        Standard dummy text ever <br /> since the unknown
                        printer took.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-20">
                  <div className="it-choose-staff style-2 d-flex align-items-center">
                    <div className="it-choose-staff-icon">
                      <span>
                        <i className="flaticon-teamwork"></i>
                      </span>
                    </div>
                    <div className="it-choose-staff-text">
                      <h6 className="it-choose-staff-title">
                        We Are Certified
                      </h6>
                      <p className="mb-0">
                        Standard dummy text ever <br /> since the unknown
                        printer took.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className="it-choose-staff style-1 d-flex align-items-center">
                    <div className="it-choose-staff-icon">
                      <span>
                        <i className="flaticon-eye"></i>
                      </span>
                    </div>
                    <div className="it-choose-staff-text">
                      <h6 className="it-choose-staff-title">
                        Duration of Service
                      </h6>
                      <p className="mb-0">
                        Standard dummy text ever <br /> since the unknown
                        printer took.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className="it-choose-staff style-2 d-flex align-items-center">
                    <div className="it-choose-staff-icon">
                      <span>
                        <i className="flaticon-laser-surgery"></i>
                      </span>
                    </div>
                    <div className="it-choose-staff-text">
                      <h6 className="it-choose-staff-title">Happy Clients</h6>
                      <p className="mb-0">
                        Standard dummy text ever <br /> since the unknown
                        printer took.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-5 col-lg-6">
            <div className="it-choose-right text-center text-lg-start p-relative">
              <div className="it-choose-thumb p-relative">
                <img src={chooseImg} alt="" />
                <Link
                  className="it-choose-play pulse popup-video"
                  to="#"
                  onClick={() => openModal()}
                >
                  <i className="fa-sharp fa-solid fa-play"></i>
                </Link>
                <div className="it-choose-shape-3 d-none d-sm-block">
                  <img src={shapeImg2} alt="" />
                </div>
                <div className="it-choose-shape-4 d-none d-sm-block">
                  <img src={shapeImg3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;
